import styled from "@emotion/styled";

export const ContentBodyContainer = styled.section`
  position: relative;
`;
